export default {
    title: "Pianificazione",
    icon: "mdi-calendar-check-outline",
    admin: true,
    groups: [],
    submenu: [{
        title: "Pianificazione",
        route: { name: "pianificazione-lab" },
        admin: true,
    }],
};
